'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('activation-code-edit', {
      url: '/admin/code/edit/:id',
      template: '<activation-code-edit></activation-code-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/edit/code-edit.routes.js